<template>
  <VModal ref="modal" @modal:hidden="$emit('closed')" disable-backdrop-click>
    <template #default>
      <div class="rounded shadow-xs w-full max-w-3xl mx-auto" @click.stop>
        <div class="rounded shadow-lg bg-white overflow-hidden">
          <div class="h-10 bg-white pl-4">
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <h1 class="text-sm">Reject Comments</h1>
              </div>
              <div class="flex-none">
                <button
                  class="h-10 w-10 inline-flex items-center justify-center hover:bg-gray-200 focus:outline-none"
                  @click="$refs.modal.close()"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
                    <path
                      d="M12 10.586l4.95-4.95 1.414 1.414-4.95
                      4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95
                      4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05
                      5.636z"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="bg-white space-y-6">
            <Loader v-if="loading" />
            <ul v-else class="w-full divide-y mt-auto">
              <li v-for="comment in comments" :key="comment.id" class="px-4 py-3">
                <CommentItem :comment="comment" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
import CommentItem from './CommentItem.vue';

export default {
  name: 'ManageAssetReviewsModal',
  components: {
    CommentItem,
  },
  props: {
    projectAssetId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      resolved: false,
      rejected: false,
    };
  },
  computed: {
    approvalRequests() {
      return this.$store.getters['ui/projectAssetApprovalRequests/itemsByParent'](
        this.projectAssetId
      );
    },
    comments() {
      return this.approvalRequests
        .reduce(
          (commentIds, approvalRequest) => [...commentIds, ...(approvalRequest.comments || [])],
          []
        )
        .map((commentId) => this.$store.state.entities.comments.byId[commentId]);
    },
  },
  created() {
    this.fetchRejectedApprovalRequests();
  },
  destroyed() {
    this.$store.dispatch('ui/projectAssetApprovalRequests/clearByParent', {
      parentId: this.projectAssetId,
    });
  },
  methods: {
    async fetchRejectedApprovalRequests() {
      try {
        this.loading = true;

        await this.$store.dispatch('ui/projectAssetApprovalRequests/load', {
          projectAssetId: this.projectAssetId,
          query: {
            filter: {
              rejected: true,
            },
            include: 'comments.user',
          },
        });

        this.resolved = true;
      } catch (error) {
        this.rejected = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
